jQuery(document).ready(function ($) {
    $(".accessible-toggle").click(function () {

        $button = $(this);

        if ($button.attr('aria-expanded') === 'false') {
            $button.attr('aria-expanded', 'true');
            $button.attr('aria-label', $button.attr('data-label-opened'));
        } else {
            $button.attr('aria-expanded', 'false');
            $button.attr('aria-label', $button.attr('data-label-closed'));
        }
    });
});